//Page to render when the user don't have access to the page

import { useTranslation } from "react-i18next";
import styled from "styled-components";

const NoPageStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

export const NoPage = () => {
    const { t } = useTranslation();
    
    return (
        <NoPageStyled>
            <span>{t('You currently have no permissions. Please contact the administrator')}</span>
        </NoPageStyled>
    );
};
